import { axios } from '@/api/axios.ts';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { TCategory, TCreateCategory } from './categories.types.ts';

export const categoriesApi = {
  getCategories: async () => {
    const response = await axios.get<TCategory[]>('categories');

    return response.data;
  },
  getCategoryById: async (id: number) => {
    const response = await axios.get<TCategory>(`categories/${id}`);

    return response.data;
  },
  createCategory: async (category: TCreateCategory) => {
    const response = await axios.post<TCategory>('categories', category);

    return response.data;
  },
  updateCategoryById: async (payload: { id: number; category: TCreateCategory }) => {
    const { id, category } = payload;
    const response = await axios.patch<TCategory>(`categories/${id}`, category);

    return response.data;
  },
  deleteCategory: async (id: number) => {
    const response = await axios.delete<TCategory>(`categories/${id}`);

    return response.data;
  },
};

export const categoriesQueries = createQueryKeys('categories', {
  getCategories: () => ({
    queryKey: ['list'],
    queryFn: () => categoriesApi.getCategories(),
  }),
  getCategoryById: (id: number) => ({
    queryKey: ['category', id],
    queryFn: () => categoriesApi.getCategoryById(id),
  }),
});
